import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12fa997d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column m-4 py-4 align-middle" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center header" }, "Start Using OTC Pro Today", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center text" }, "Enter your payment information and get started!", -1))
const _hoisted_4 = { class: "d-flex mt-3 justify-content-center text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_collapsable_container = _resolveComponent("collapsable-container")!

  return (_openBlock(), _createBlock(_component_collapsable_container, { border: false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            class: "blue-circle me-2",
            size: "xs",
            icon: ['fas', 'circle']
          }),
          _createVNode(_component_font_awesome_icon, {
            class: "blue-circle ms-2",
            size: "xs",
            icon: ['fas', 'circle']
          })
        ])
      ])
    ]),
    _: 1
  }))
}